import React, { useCallback, useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from '~/ui/styled'
import { Flex, StartFlex, CenterFlex, BetweenFlex, Button, Text, IconFont } from "~components/El"
import { AuthLayout } from "~components/Layout"
import { VerifyCodeInput }  from "~components/VerifyCodeInput"
import { VerifyCodeScreenProps } from "./types"
import { useStores } from "~models"
import { globalToast, hideContact } from "~utils"
import useNavigation from "~hooks/useNavigation"
import { AuthTipText } from "../components/auth-tip-text"

const Dotted = styled(CenterFlex)`
  width: 4px;
  height: 4px;
  margin-right: 10px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.secondaryText};
`
const tips = [
  "验证码有效期为10分钟",
  "如果没有收到验证码，请检查垃圾邮件文件夹",
  "确保输入的邮箱是您注册时使用的",
]

const VerifyCode: React.FC<VerifyCodeScreenProps> = ({ route }) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const params = route?.params ?? {}
  // console.log("params", params)
  const { apiStore, walletStore, authStore } = useStores()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (code: string) => {
    try {
      setLoading(true)
      if (params.data?.type === "register") {
        const data = await apiStore.register({ ...params.data, verify_code: code })
        await authStore.login(data)
        walletStore.getWalletInfo()
        authStore.setHaveBeenPrivacy(true)
        setLoading(false)
      } else if (params.data?.type === "find_password") {
        const res = await apiStore.findPassword({ ...params.data, verify_code: code })
        if (res?.verify_token) {
          navigation.navigate("ResetPassword", {
            username: params.data?.username,
            email: params.data?.email,
            phone: params.data?.phone,
            code: res?.verify_token,
          })
        }
        setLoading(false)
      }
    } catch (error) {
      globalToast.show(error?.message || "验证失败")
      setLoading(false)
    }
  }
  const sendCode = useCallback(async () => {
    try {
      const data = params.data
      if (!data?.email && !data?.phone) {
        throw new Error("缺少验证信息")
      }

      if (data.email) {
        const res = await apiStore.getEmailSms({ email: data.email, event: "bind_email" })
        if (res?.code !== 200) {
          throw new Error((res as { message?: string })?.message || "发送失败")
        }
        globalToast.show((res as { message?: string })?.message || "发送成功")
        return
      }

      const res = await apiStore.sendPhoneCodeByNotBound({
        phone: data.phone!,
        event: "register_phone",
        country_code: data.country_code || "+86",
      })
      if (res?.code !== 200) {
        throw new Error((res as { message?: string })?.message || "发送失败")
      }
      globalToast.show((res as { message?: string })?.message || "发送成功")
    } catch (error: any) {
      globalToast.show(error?.message || "发送失败")
      throw error
    }
  }, [apiStore, params.data])
  return (
    <AuthLayout
      title="验证码验证"
      subtitle={`验证码已发送至${hideContact(params.data?.email || params.data?.phone || "")}`}
    >
      <StartFlex flexDirection="column" width="100%" padding="12px 20px">
        <CenterFlex width="100%" mt="10px">
          <VerifyCodeInput loading={loading} onSubmit={handleSubmit} onResend={sendCode} />
        </CenterFlex>
        <BetweenFlex width="100%" padding="30px 0">
          <StartFlex width="40%" height="1px" bg={theme.colors.border}></StartFlex>
          <Text color={theme.colors.secondaryText} fontSize={theme.fontSizes.md}>或</Text>
          <StartFlex width="40%" height="1px" bg={theme.colors.border}></StartFlex>
        </BetweenFlex>
        <CenterFlex width="100%">
          <Button flexDirection="row" onClick={() => { navigation.navigate("Login") }}>
            <Text color={theme.colors.primaryText} fontSize={theme.fontSizes.lg}>返回登录</Text>
          </Button>
        </CenterFlex>
        <Flex
          flexDirection="column"
          width="100%"
          mt="10px"
          padding="10px 12px"
          borderRadius="8px"
          bg={theme.colors.background}
        >
          <Text color={theme.colors.danger} fontSize={theme.fontSizes.lg}>
            <IconFont name="wxts" size={16} color={theme.colors.danger} />&nbsp;&nbsp;温馨提示
          </Text>
          <Flex
            flexDirection="column"
            width="100%"
            mt="10px"
            pl="26px"
          >
            {tips.map((text, index) => (
              <StartFlex key={index} >
                <Dotted />
                <AuthTipText text={text} />
              </StartFlex>
            ))}
          </Flex>
        </Flex>
      </StartFlex>
    </AuthLayout>
  )
}
export default observer(VerifyCode)
